import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ToastController} from 'ionic-angular';
import { Configuration } from '../../constants/config';
import { ReportsServiceProvider } from '../../providers/reports-service/reports-service';
import { SettingsServiceProvider } from '../../providers/settings-service/settings-service';

/**
 * Generated class for the ReportsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-reports',
    templateUrl: 'reports.html',
})
export class ReportsPage {

    reportSelect = 1;
    dateFrom: string = new Date().toISOString();
    dateTo: string = new Date().toISOString();
    paymenType = 0;
    email = "";

    constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public _configuration: Configuration, public reportsService: ReportsServiceProvider, public settingsService: SettingsServiceProvider) {
        this.load();
    }

    /**
     * @Info Load
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    load(){
        let data = {IdSettings: 6, token: this._configuration.token};
        this.settingsService.read(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    if (response.Success) {
                        this.email = response.Content[0].Value;
                    }else{
                        let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                        toast.present();
                    }
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }

    /**
     * @Info Send report
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    sendReport(){

        let date1 = new Date(this.dateFrom);
        date1.setHours(0);
        date1.setMinutes(0);
        date1.setSeconds(0);
        date1.setMilliseconds(0);
        let date2 = new Date(this.dateTo);
        date2.setHours(0);
        date2.setMinutes(0);
        date2.setSeconds(0);
        date2.setMilliseconds(0);

        let getDate = function(date) {
            var mm = date.getMonth() + 1; // getMonth() is zero-based
            var dd = date.getDate();
            return [date.getFullYear(),
                (mm>9 ? '' : '0') + mm,
                (dd>9 ? '' : '0') + dd
            ].join('/');
        };

        let msg = "";

        if (!msg && (date1 > date2)){
            msg = "The date from can not be longer than the date to";
        }
        if (!msg && !this.email){
            msg = "Enter a valid Email Address";
        }

        if (msg) {
            let toast = this.toastCtrl.create({
                message: msg,
                position: 'middle',
                duration: 3000
            });
            toast.present();
        }else{
            if (this.reportSelect == 1){
                // Sales Report
                let data = {
                    IdBranch: this._configuration.CustomerData.IdBranch,
                    StartDate: getDate(date1),
                    EndDate: getDate(date2),
                    PaymentType: this.paymenType,
                    Mail: this.email,
                    token: this._configuration.token
                };
                this.reportsService.sendSalesReport(data)
                    .then(data => {
                        let response : any = data;
                        if (!response.Error){
                            if (response.Success) {
                                let toast = this.toastCtrl.create({message: "The report has been sent successfully",position: 'middle',duration: 3000});
                                toast.present();
                            }else{
                                let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                                toast.present();
                            }
                        }else{
                            let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                            toast.present();
                        }
                    });
            }else{
                // Inventory Report
                let data = {
                    IdBranch: this._configuration.CustomerData.IdBranch,
                    Mail: this.email,
                    token: this._configuration.token
                };
                this.reportsService.sendInventoryReport(data)
                    .then(data => {
                        let response : any = data;
                        if (!response.Error){
                            if (response.Success) {
                                let toast = this.toastCtrl.create({message: "The report has been sent successfully",position: 'middle',duration: 3000});
                                toast.present();
                            }else{
                                let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                                toast.present();
                            }
                        }else{
                            let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                            toast.present();
                        }
                    });
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts